import PropTypes from 'prop-types';
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ContentContainer, StyledDrawer } from './Drawer.style';
import Backdrop from '../../styled components/Backdrop';

/**
 * A drawer displays additional content on the right side the screen and can be toggled open and closed.
 * When the drawer is open, a backdrop is rendered above the original content.
 *
 * The drawer is closed by clicking anywhere outside it, calling its `closeDrawer` function prop.
 */
const Drawer = (props) => {
  const { isDrawerVisible, closeDrawer, children } = props;

  return (
    <AnimatePresence>
      {isDrawerVisible && (
        <StyledDrawer onClick={closeDrawer}>
          <motion.div
            initial={{
              opacity: 0
            }}
            animate={{
              opacity: 1
            }}
            exit={{
              opacity: 0
            }}
            transition={{ ease: 'easeOut', duration: 0.5 }}
            key="backdrop-drawer"
          >
            <Backdrop />
          </motion.div>
          <ContentContainer
            data-test-drawer
            exit={{ x: Drawer.drawerWidth }}
            initial={{ x: Drawer.drawerWidth }}
            animate={{ x: '0%' }}
            transition={{ ease: 'easeOut', duration: 0.3 }}
            key="content-drawer"
          >
            {children}
          </ContentContainer>
        </StyledDrawer>
      )}
    </AnimatePresence>
  );
};

Drawer.drawerWidth = '250px';

Drawer.propTypes = {
  isDrawerVisible: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default Drawer;
